import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.inputs = document.querySelectorAll('input[required]:not([data-reveal-validation-event-listener-added="true"]), select[required]:not([data-reveal-validation-event-listener-added="true"]), textarea[required]:not([data-reveal-validation-event-listener-added="true"]), select[data-maybe-required]:not([data-reveal-validation-event-listener-added="true"]), input[data-maybe-required]:not([data-reveal-validation-event-listener-added="true"])')
    this.inputs.forEach((input) => {
      input.addEventListener('invalid', this.handleInvalid)
      input.setAttribute('data-reveal-validation-event-listener-added', 'true');
    })
  }

  disconnect() {
    this.inputs.forEach((input) => {
      input.removeEventListener('invalid', this.handleInvalid)
      input.removeAttribute('data-reveal-validation-event-listener-added');
    })
  }

  handleInvalid(event) {
    event.preventDefault();
    const input = event.currentTarget
    // Only focus if the input is not in view
    if(input.getClientRects().length != 0) {
      event.currentTarget.focus();
    }
    event.currentTarget.classList.add('reveal-validation');
  }
}
